import moment from 'moment-timezone';
import {
    APP_TIMEZONE,
    TIME_FORMAT,
    DATETIME_FORMAT,
    DATE_FORMAT,
    TIME_LONG_FORMAT,
} from './constants';

export const convertToBST = (date) => moment(date).tz(APP_TIMEZONE);

export const inAppTimezone = (date) => moment(date).tz(APP_TIMEZONE);

export const tzFormatTime = (date) =>
    moment(date)
        .tz(APP_TIMEZONE)
        .format(TIME_FORMAT);

export const tzFormatTimeLong = (date) =>
    moment(date)
        .tz(APP_TIMEZONE)
        .format(TIME_LONG_FORMAT);

export const tzFormatDate = (date) =>
    moment(date)
        .tz(APP_TIMEZONE)
        .format(DATE_FORMAT);

export const tzFormat = (date, format) =>
    moment(date)
        .tz(APP_TIMEZONE)
        .format(format);

export const tzFormatDateTime = (date) =>
    moment(date)
        .tz(APP_TIMEZONE)
        .format(DATETIME_FORMAT);
